import { RenderNodeConfig } from 'dto/NodeConfig';
export class FlowResultDto {


        public FlowResultId:string;

        /**
        * True if flow is totaly finished and is the entire path is processed
        */
        public Finished:boolean;

        public FlowId:string;

        public StartDate:Date;

        public TimeToProcess:number;

        public Payload:any;

        /**
        * List with Nodes that require user input. Provided values should be passed to the flow as Payload data.
        */
        public UiNodesToRender:RenderNodeConfig[];
}


// WEBPACK FOOTER //
// C:/git/flowdesigner/src/dto/FlowResultDto.ts